module.exports = __webpack_public_path__ + "img/pago_movil.ff32bf8e.jpg";